"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.eventsAtLocation = eventsAtLocation;
exports.scanEventChoices = scanEventChoices;
exports.resolveScanEventId = resolveScanEventId;
exports.isEventRequiredOnly = isEventRequiredOnly;
const ticket_1 = require("../types/ticket");
/**
 * Scan-eligible events attached to the agent's current location.
 * An empty location id yields an empty list so callers can fall back to org-wide.
 */
function eventsAtLocation(events, locationId) {
    if (locationId == null || locationId === '') {
        return [];
    }
    const id = String(locationId);
    return events.filter((event) => (event.locations ?? []).some((location) => String(location.id) === id));
}
/**
 * Events the agent may pick for this scan: the location's events when it has
 * any, otherwise the org-wide eligible list.
 */
function scanEventChoices(events, locationId) {
    const atLocation = eventsAtLocation(events, locationId);
    return atLocation.length > 0 ? atLocation : events;
}
/**
 * Resolve which event a scan should count against, without prompting:
 * 1. A stored sticky id that is still in the current choice list
 * 2. The sole event at the location (or org-wide, when the location has none)
 * 3. null — the scanner must ask
 */
function resolveScanEventId(events, storedId, locationId) {
    const choices = scanEventChoices(events, locationId);
    if (storedId != null && storedId !== '' && choices.some((event) => event.id === storedId)) {
        return storedId;
    }
    if (choices.length === 1) {
        return choices[0].id;
    }
    return null;
}
function isEventRequiredOnly(errors) {
    const keys = Object.keys(errors ?? {});
    return keys.length === 1 && keys[0] === ticket_1.TicketItemValidationStatus.INVALID_EVENT_REQUIRED;
}
